import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Menu, Dropdown, Button } from 'antd';
import { AlignLeftOutlined, UserOutlined, DownOutlined } from '@ant-design/icons';
import { TAB_SIZE } from "../../constants/ThemeSetting";
import { useSelector } from "react-redux";
import { useMediaQuery } from 'react-responsive'
import Auxiliary from "util/Auxiliary";
import RequestHandler from "../../util/RequestHandler";
import { Scrollbars } from 'react-custom-scrollbars';


const tenantId = localStorage.getItem("tenantId");
const userId = localStorage.getItem("userId");

const Topbar = () => {
  const history = useHistory();
  const [tenantAccounts, setTenantAccounts] = useState([]);
  const [currentTenantAccount, setcurrentTenantAccount] = useState("");
  const [isGroupUser, setIsGroupUser] = useState(false);
  const isTabletOrMobileDevice = useMediaQuery({ query: "(max-device-width: 1224px)" });

  function handleMenuClick(e) {
    if (e.key == "konsolide") {
      history.push(`/consolidated-bank`);
      return;
    }

    RequestHandler.get(`/Auth/ChangeTenant/${userId}/${e.key}`, undefined, { rawResponse: true }).then((response) => {
      if (response.status === 200) {
        RequestHandler.setUserInfo(response);
        history.push(`/home`);
        window.location.reload();
      }
    });
  }

  useEffect(() => {
    RequestHandler.get(`/User/GetUserTenants/${userId}`).then((response) => {
      setTenantAccounts(response);

      response.map((tenantAccount) => {
        if (tenantAccount.id === tenantId) {
          setcurrentTenantAccount(tenantAccount.name);
        }
      });
    });

    RequestHandler.get(`/User/IsGroupUser`).then((response) => {
      setIsGroupUser(response);
    });
  }, [setTenantAccounts]);

  const { locale, width, navCollapsed, navStyle } = useSelector(({ settings }) => settings);

  const menu = (
    <Scrollbars 
    autoHide
    autoHideTimeout={1000}
    autoHideDuration={200}
    autoHeight
    autoHeightMin={0}
    autoHeightMax={500}
    thumbMinSize={30}
    universal={true}>
        <Menu onClick={handleMenuClick}>
          {tenantAccounts.map((item, index) => (
            <Menu.Item key={item.id} icon={<UserOutlined />} disabled={item.id === tenantId}>
              {item.name}
            </Menu.Item>
          ))}
          {
            isGroupUser === true ? <Menu.Item key="konsolide" icon={<AlignLeftOutlined />}>
              Konsolide
            </Menu.Item>
              : null
          }
        </Menu>
    </Scrollbars>

  );

  return (
    <ul className="gx-header-notifications gx-ml-auto" >
      <Dropdown overlay={menu}>
        <Button style={{ marginTop: 19,height:40,borderRadius:10,padding:'0 15px' }} >
          {isTabletOrMobileDevice ? null : currentTenantAccount}  
          <img src={require(`assets/images/Icons/ChevronDown.svg`)} alt="icon" />
        </Button>
      </Dropdown>
      {width >= TAB_SIZE ? null :
        <Auxiliary>
          <li className="gx-user-nav"></li>
        </Auxiliary>
      }
    </ul>
  );
};

export default Topbar;
